import en from './en.json'
import tw from './zh-TW.json'

export default {
  en,
  'zh-TW': tw
}
